site.megamenu = {
	init:function() {
		var $mainmenu = $('#mainmenu');
		$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"/>');
		$mainmenu.on('click touchstart', function(e) {
			e.stopPropagation();
		});

		site.megamenu.background();

		$('.level1.children > a',$mainmenu).on('click touchstart', function (e) {
			if ($(document).width()+15 >= 992 && !$('body').hasClass('stillingar')) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('body').addClass('megamenu-open');
					$('.level1.open', $mainmenu).removeClass('open');
					$('.megamenu', $mainmenu).removeAttr('style');
					$(this).parent().addClass('open');
					var $megamenu = $(this).parent().find('.megamenu'),
						$megamenuHeight = $megamenu[0].scrollHeight + 5 + 135;
					$megamenu.css('max-height', $megamenuHeight);
					$('#megamenuBg').css('height', $megamenuHeight);
					$('#pageContainer').css('min-height', $megamenuHeight+142);
				}

				$('body.megamenu-open').on('click touchstart', function (e) {
					site.megamenu.close();
				});
			}
		});

		//$('.level2.children > a span','.megamenu').unwrap();
	},

	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.megamenu', $mainmenu).removeAttr('style');
		$('#megamenuBg').removeAttr('style');
		$('.level1.open', $mainmenu).removeClass('open');
		$('#pageContainer').removeAttr('style');

		if ($body.hasClass('megamenu-open')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
			},400);
		}
		$('body').removeClass('megamenu-open');
	},

	background:function() {
		var $mainmenu = $('#mainmenu'),
			$header = $('#header');
		$header.append('<div id="megamenuBg" />');
		$(window).resize(function() {
			if ($('body').hasClass('megamenu-open')) {
				var $megamenu = $('.open .megamenu', $mainmenu),
					$megamenuHeight = $megamenu[0].scrollHeight + 135;
				$megamenu.css('max-height', $megamenuHeight);
				$('#megamenuBg').css('height', $megamenuHeight);
				$('#pageContainer').css('min-height', $megamenuHeight+142);
			}
		});

		$('#megamenuBg').on('click touchstart', function(e) {
			e.stopPropagation();
		});

		//site.megamenu.appendSearch();
	},

	appendSearch: function() {
		var $bg = $('#megamenuBg'),
			$mSearchBox = $('#searchBox').clone().removeAttr('id').attr('id','mSearchBox');
		$bg.prepend($mSearchBox);

		$('[id]', $mSearchBox).each(function() {
			var $this = $(this),
				$id = $this.attr('id'),
				$newId = 'mm'+$id.substr(0,1).toUpperCase()+$id.substr(1),
				$label = $('label[for="'+$id+'"]', $mSearchBox);

			if ($label.length > 0) {
				$label.attr('for', $newId);
			}
			$this.attr('id', $newId);

			if (typeof $this.attr('name') !== typeof undefined) {
				$this.attr('name', $newId);
			}
		});
	}
};
